import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Hero } from '../components/Hero';
import { AboutCaro } from '../components/AboutCaro';
import { Gallery } from '../components/Gallery';
import { CaroBeginning } from '../components/CaroBeginning';
import { Footer } from '../components/Footer';
import { CookieConsent } from '../components/CookieConsent';
import { LanguageToggle } from '../components/LanguageToggle';
import { motion } from 'framer-motion';
import { useTranslation } from '../lib/i18n';
export function LandingPage() {
  const {
    t
  } = useTranslation();
  return <HelmetProvider data-id="element-278">
      <div className="min-h-screen bg-background text-text-primary selection:bg-hotpink selection:text-white font-sans" data-id="element-279">
        <Helmet data-id="element-280">
          <title data-id="element-281">
            Caro Loesel – Offizielle Webseite | Curvy Blond mit Tattoos
          </title>
          <meta name="description" content="Caro Loesel offiziell entdecken: Kurviges blondes Model mit Tattoos und natürlicher Ausstrahlung. Exklusive Plattformen & Modelbuchung." data-id="element-282" />
          <meta property="og:title" content="Caro Loesel – Offizielle Webseite | Curvy Blond mit Tattoos" data-id="element-283" />
          <meta property="og:description" content="Caro Loesel offiziell entdecken: Kurviges blondes Model mit Tattoos und natürlicher Ausstrahlung. Exklusive Plattformen & Modelbuchung." data-id="element-284" />
          <meta property="og:type" content="website" data-id="element-285" />
          <meta name="theme-color" content="#FFFFFF" data-id="element-286" />
          <html lang="de" data-id="element-287" />
        </Helmet>

        <LanguageToggle data-id="element-288" />

        <main className="relative z-10" data-id="element-289">
          <Hero data-id="element-290" />

          {/* Intro text — below the fold */}
          <motion.section initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="pt-16 pb-8 px-4 text-center max-w-xl mx-auto" data-id="element-291">
            <p className="text-text-secondary text-lg md:text-xl leading-relaxed font-light font-sans" data-id="element-292">
              {t.intro}
            </p>
          </motion.section>

          {/* New Gallery Section */}
          <Gallery data-id="element-293" />

          <AboutCaro data-id="element-294" />

          {/* Caro Beginning Section */}
          <CaroBeginning data-id="element-295" />

          {/* Closing CTA Section */}
          <motion.section initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="py-20 px-4 text-center max-w-2xl mx-auto" data-id="element-296">
            <div className="w-24 h-px bg-gradient-to-r from-transparent via-hotpink to-transparent mx-auto mb-8 opacity-60" data-id="element-297" />
            <p className="text-xl md:text-2xl font-serif italic text-[#1A1A1A] leading-relaxed" data-id="element-298">
              {t.closingCta}
            </p>
            <div className="w-24 h-px bg-gradient-to-r from-transparent via-hotpink to-transparent mx-auto mt-8 opacity-60" data-id="element-299" />
          </motion.section>
        </main>

        <Footer data-id="element-300" />

        {/* Cookie Consent Banner */}
        <CookieConsent data-id="element-301" />
      </div>
    </HelmetProvider>;
}